import { selectNewbuildingInfo } from './selectNewbuildingInfo';
import { IApplicationState } from '../../types/redux';

export const selectIsNewbuildingClusterActive = (state: IApplicationState): boolean => {
  const newbuildingInfo = selectNewbuildingInfo(state);

  return Boolean(newbuildingInfo);
};
